import React, {
  useEffect, useState,
} from 'react';
import KdsExpoStationScreens from '@components/KdsExpoStationScreens';
import { logout } from '@reducers/oauth';
import KdsBuildStationScreens from '@components/KdsBuildStationScreens';
import { connect } from 'react-redux';
import { APP_CONFIG } from '@constants';
import { bindActionCreators } from 'redux';
import styles from './index.module.scss';
import cn from 'classnames';
import {
  getStoreChecks,
  subscribeToStoreChecks,
  authenticate,
} from '../../sockets/communicator';
import {
  bumpApiCall,
  receipePdfApiCall,
  prepStartAll,
  getAllCheckPreps,
  layoutApiCall,
  layoutUpdateApiCall,
  duplicateData,
  reprioritize,
  getModifierRecipePdf,
  checkReScheduleRequest,
  recallApiCall
} from '@reducers/storeChecks';
import { setNotification } from '@reducers/notification';
import Modal from '@components/common/Modal';
import { LABEL } from '../../veriables';
import Loader from '@components/common/Loader';
import KdsPrepStation from '@components/kdsPrepStationScreens';
import { getKdsCheckList, getKdsCheckPrepList, updatePrepObject } from '@reducers/kds';
import moment from 'moment';
import { HexColorGenerator } from './hexColorGenerator';
import filterIcon from '@assets/images/KDSICONS/filterIcon.svg';
import sortIcon from '@assets/images/KDSICONS/sortIcon.svg';
import LessThanIcon from '@assets/images/KDSICONS/LessThanIcon.svg';
import greaterIcon from '@assets/images/KDSICONS/greaterIcon.svg'
import ToggleSwitch from '../../components/common/formElements/ToggleSwitch/index';
import KdsEmptyStation from '../../components/kdsEmptyStationScreen/index';
import pdfCancel from '@assets/images/KDSICONS/pdfCancel.svg';

const KitchenDisplaySystem = ({
  checkListHashTable,
  checkPrepsListHashTable,
  UpdatedcheckPrepsListHashTable,
  auth,
  socketConnected,
  menus,
  deviceInfo,
  expoObject,
  kdsObject,
  kdsExpoObject,
  inActiveData,
  prepObject,
  lastHourCount,
  lastCheckDate,
  footerItemSelectionId,
  ...props
}) => {
  const [activeScreenType, setActiveScreenType] = useState(() => { return (!deviceInfo.deviceGroup || !deviceInfo.deviceGroup.startMode) ? 0 : deviceInfo.deviceGroup.startMode === 1 ? 1 : deviceInfo.deviceGroup.startMode === 2 ? 2 : 0; });
  const [currentItemType, setCurrentItemType] = useState('all');
  const [isOpen, setIsopen] = useState(false)
  const [errordata, SetErrordata] = useState('');
  const [isLayoutOpen, setIsLayoutopen] = useState(false)
  const [layoutdata, SetLayoutdata] = useState([]);
  const checkPerPage = 6;
  const itemsPerPage = 5;
  const columnCount = Number(JSON.parse(window.sessionStorage.getItem('deviceInfo')).columnCount);
  const rowCount = Number(JSON.parse(window.sessionStorage.getItem('deviceInfo')).rowCount);
  const [counter, setCount] = useState(0);
  const [toggle, setToggle] = useState(false)
  const themeProperties = JSON.parse(window.sessionStorage.getItem('themeProperties'))?.styleUrl;
  const storeId = Number(window.sessionStorage.getItem('storeId'))
  const [isDuplicatePopUpOpen, setIsDuplicatePopUpOpen] = useState(false);
  const [history, setIsHistory] = useState(false);
  const [duplicatePopupData, setDuplicatePopupData] = useState([]);
  const [duplicateCheckedStatus, setDuplicateCheckedStatus] = useState({ [deviceInfo?.kdsMirrorDeviceId ? deviceInfo?.kdsMirrorDeviceId : deviceInfo.deviceId]: '#bbbbbb' });
  const [tempDuplicateCheckedStatus, setTempDuplicateCheckedStatus] = useState(duplicateCheckedStatus);
  const [duplicateDeviceIds, setDuplicateDeviceIds] = useState({ [deviceInfo?.kdsMirrorDeviceId ? deviceInfo?.kdsMirrorDeviceId : deviceInfo.deviceId]: '#bbbbbb' });
  const [prioritizedItem, setPriorityItem] = useState({
    selectedItemId: null,
    dropItemId: null
  });
  const [isPrioritize, setPrioritize] = useState(false);
  const [isDropItem, setConfirmDropItem] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [selectedHistoryData, setSelectedHistoryData] = useState('');
  const [headerColor, setHeaderColor] = useState('gray')
  const [currentHistoryPage, setCurrentHistoryPage] =  useState(1);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const totalHistoryPage = historyData ? Math.ceil(historyData[selectedHistoryData]?.length / 5) : 1;
  const [filterData, setFilterData] = useState({});

  // States for recall modal
  const [isRecallOpen, setIsRecallOpen]  = useState(false);
  const [recallData, setRecallData] = useState({});
  const handleShowRecallModal = () => { setIsRecallOpen(!isRecallOpen);setIsDuplicatePopUpOpen(false) }
  const [selectedRecallData ,setSelectedRecallData] = useState(0);
  const [currentRecallPage, setCurrentRecallPage] =  useState(1);
  const [testRecall, setTestRecall] = useState([]);
  const [pdfUrl, setPdfUrl] = useState([])
  const totalRecallPage = (testRecall && testRecall.length > 0) ? Math.ceil(testRecall[selectedRecallData]?.length/ 5):1;
  const [lastActiveTime, setLastActiveTime] = useState(new Date());

  // recipe modal states
  const [recipeModalData, setRecipeModalData] = useState({isOpen: false, itemName: ''});
  const kdsSettings = deviceInfo?.deviceGroup && deviceInfo?.deviceGroup?.kdsSettings;
  const states = [{ name: "CURRENT", color: '#FFFFFF' }, { name: "STARTED", color: '#CEEF69' }, { name: "DELAYED", color: '#F58B91' }, { name: "FUTURE", color: '#BCE7F1' }];
  const [currentState, setCurrentState] = useState(0);
 
  // history Modal variable
  const [isStationEmpty, setIsStationEmpty] = useState(true);

  const toggleState = () => {
    // Increment the current state index, and wrap around to 0 if it exceeds the number of states
    const newStateIndex = (currentState + 1) % states.length;

    // Update the state to the new state
    setCurrentState(newStateIndex);
  };

  useEffect(() =>{ 
  // console.log("State", testRecall)
    if(testRecall && testRecall.length > 0){
     setSelectedRecallData(0) 
    } 
  },[testRecall])
  
  useEffect(() => {
    if(testRecall && testRecall.length > 0){
      const currentTime = moment();
      const filteredArr = testRecall.filter((el) =>{
      const differenceInSeconds = moment(currentTime).diff(el[0].bumpTime, 'seconds');
       return differenceInSeconds < auth?.kdsRecallTime      
      })
      setTestRecall(filteredArr)
    }
  }, [isRecallOpen])

  const bumpApiSelected = (data, type, items) => {
    let datatosend = {};
    if (type === 'prepSelectedBump') {
      datatosend = {
        storeId: storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: data.checkPrep.checkHeader.employeeId,
        checkHeaderId: data.checkPrep.checkHeader.id,
        checkPrepId: data.checkPrep.id,
        items: [{ entityId: data.entityId, isModifier: data.isModifier }]
      }
    } else if (type === 'buildSelectedBump') {
      datatosend = {
        storeId: storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: data[0].checkPrep.checkHeader.employeeId,
        checkHeaderId: data[0].checkPrep.checkHeader.id,
        checkPrepId: data[0].checkPrep.id,
        items: []
      }
      for (let index = 0; index < items.length; index++) {
        const element = items[index];
        let obj = { entityId: element.entityId, isModifier: element.isModifier }
        datatosend['items'].push(obj);
      }
      
    } else if (type === 'expoSelectedBump') {
      datatosend = {
        storeId: storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: data.checkHeader.employeeId,
        checkHeaderId: data.checkHeader.id,
        checkPrepId: data.id,
        items: items
      }
    }
    props.bumpApiCall(datatosend).then((res) => {
      if(type === 'buildSelectedBump'){
        const tempRecallArr = [];
        const resArr = res?.buildItems?.length > 0 ? res?.buildItems : [];
        for (let index = 0; index < resArr?.length; index++) {
          const element = resArr[index];
          if(element?.buildStatus === 8 && items?.some((val) => val?.entityId === element?.entityId)){
            const recallObj = {...element, bumpTime: moment(), checkPrep: res}
            tempRecallArr.push(recallObj)
          }
        }
        if(tempRecallArr?.length > 0){
          setTestRecall((prev) => [...prev, tempRecallArr])
        } 
      }
      else if(type === 'prepSelectedBump'){
        const tempRecallArr = [];
        const resArr = res?.prepItems?.length > 0 ? res?.prepItems : [];
        for (let index = 0; index < resArr?.length; index++) {
          const element = resArr[index];
          if((element?.prepStatus === 8) && (element.entityId === data?.entityId)){
            const recallObj = {...element, bumpTime: moment(), checkPrep: res}
            tempRecallArr.push(recallObj)
          }
        }
        if(tempRecallArr?.length > 0){
          setTestRecall((prev) => [...prev, tempRecallArr])
        } 
      }

    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: "One or more items did not bump due to errors. please check order tickets and try again"
      });
    })
  }

  const receipePdfApiCall = (storeId,menuItemId, isModifier) =>{

    const recipeNotification =() =>{
      props.setNotification({
        type: 'danger',
        message: 'Recipe Not Available!'
      });
    }
    
    if(!isModifier){
      props.receipePdfApiCall(storeId,menuItemId).then((res) => {
        if (res.url.length === 0) {
          recipeNotification();
        } else {
          setPdfUrl(res.url)
        }
      }).catch((err) => {console.log(err);})
    }
    else {
      props.getModifierRecipePdf(storeId,menuItemId).then((res) =>{
        if(res.url.length === 0){
          recipeNotification();
        }
        else {
          setPdfUrl(res.url)
        }
      })
    }
  }

  const bumpApiCall = (item, type, data) => {
    let datatosend = {}
    if (type == 'expo') {
      datatosend = {
        storeId: storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: item.checkHeader.employeeId,
        checkHeaderId: item.checkHeader.id,
        checkPrepId: item.id,
        items: []
      }
      for (let index = 0; index < item.expoItems.length; index++) {
        const element = item.expoItems[index];
        let obj = { entityId: element.entityId, isModifier: element.isModifier }
        datatosend['items'].push(obj);
      }
    } else if (type == 'build') {
      datatosend = {
        storeId: storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: item[0].checkPrep.checkHeader.employeeId,
        checkHeaderId: item[0].checkPrep.checkHeader.id,
        checkPrepId: item[0].checkPrep.id,
        items: []
      }
      for (let index = 0; index < item.length; index++) {
        const element = item[index];
        let obj = { entityId: element.entityId, isModifier: element.isModifier }
        datatosend['items'].push(obj);
      }
    } else if (type == 'prep') {
      datatosend = {
        storeId: storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: item.checkHeader.employeeId,
        checkHeaderId: item.checkHeader.id,
        checkPrepId: item.id,
        items: [{ entityId: data.entityId, isModifier: data.isModifier }]
      }
    } else if (type == 'prepTile') {
      datatosend = {
        storeId: storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: item[0].checkPrep.checkHeader.employeeId,
        checkHeaderId: item[0].checkPrep.checkHeader.id,
        checkPrepId: item[0].checkPrep.id,
        items: []
      }
      for (let index = 0; index < item.length; index++) {
        const element = item[index];
        let obj = { entityId: element.entityId, isModifier: element.isModifier }
        datatosend['items'].push(obj);
      }
    }
    props.bumpApiCall(datatosend).then((res) => {
      if(type == 'build'){
        const resArr = res?.buildItems?.length > 0 ? res?.buildItems : [];
        const tempRecallArr = [];
        for (let index = 0; index < resArr?.length; index++) {
          const element = resArr[index];
          if(element?.buildStatus === 8 && 
              item?.some((val) => (val?.entityId === element?.entityId) && val?.buildStatus !== 8)
            ){
            const recallObj = {...element, bumpTime: moment(), checkPrep: res, warningColor: item[0]?.warningColor};
            tempRecallArr.push(recallObj);
          }
        }
        if(tempRecallArr?.length > 0){
          setTestRecall((prev) => [...prev, tempRecallArr]);
        }
      }
      else if(type == 'prepTile'){
        const resArr = res?.prepItems?.length > 0 ? res?.prepItems : [];
        const tempRecallArr = [];
        for (let index = 0; index < resArr?.length; index++) {
          const element = resArr[index];          
          if(element?.prepStatus === 8 &&
              item?.some((val) => (val?.entityId === element?.entityId) && val?.prepStatus !== 8)
            ){
            const recallObj = {...element, bumpTime: moment(), checkPrep: res, warningColor: item[0]?.warningColor}
            tempRecallArr.push(recallObj)
          }
        }
        if(tempRecallArr?.length > 0){
          setTestRecall((prev) => [...prev, tempRecallArr])
        }
      }
    }).catch((err) => {
      setIsopen(true)
      SetErrordata(err.message)
    });
  }
  const layoutApi = () => {
    props.layoutApiCall(storeId).then((res) => {
      if (res.length === 0) {
        props.setNotification({
          type: 'danger',
          message: 'No additional layouts defined'
        });
      } else {
        SetLayoutdata(res);
        setIsLayoutopen(true)
        setIsDuplicatePopUpOpen(false)
      }
    }).catch((err) => {
      console.log(err);
    })
  }

  const duplicateData = () => {
    props.duplicateData(deviceInfo?.deviceId).then((res) => {
      setIsDuplicatePopUpOpen(true)
      setIsLayoutopen(false)
      setDuplicatePopupData(res);
    }).catch((err) => {
      console.log(err);
    })
  }

  const History = () => {
    setIsHistory(!history)
    setIsLayoutopen(false)
    setIsDuplicatePopUpOpen(false)
  }

  const handleItemDrop = (dropItemId) => {
    const userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
    const dataToSend = {
      storeId: deviceInfo.storeId,
      sourceCheckPrepId: prioritizedItem?.selectedItemId,
      destinationCheckPrepId: prioritizedItem?.dropItemId || dropItemId,
      deviceId: deviceInfo.deviceId,
      employeeId: userInfo.id,
    }
    props.reprioritize(dataToSend).then((data) => {
      setPrioritize(false);
      setPriorityItem({ selectedItemId: null, dropItemId: null });
      setConfirmDropItem(false);
    }).catch((error) => {
      props.setNotification({
        type: 'danger',
        message: error.message
      });
      setConfirmDropItem(false);
    })
  };

  const layoutUpdate = (data) => {
    props.layoutUpdateApiCall(data.id, data.enabled ? 'false' : 'true').then((res) => {
      setIsLayoutopen(false)
      setShowHamburgerMenu(false)
    }).catch((err) => {
    })
  }

  const prepStartAll = (item, type, data) => {
    const storeId = Number(window.sessionStorage.getItem('storeId'))
    let datatosend = {}
    if (type == 'expo') {
      datatosend = {
        storeId: storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: item.checkHeader.employeeId,
        checkHeaderId: item.checkHeader.id,
        checkPrepId: item.id
      }
    } else if (type == 'build') {
      datatosend = {
        storeId: storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: item.checkPrep.checkHeader.employeeId,
        checkHeaderId: item.checkPrep.checkHeader.id,
        checkPrepId: item.checkPrep.id,
        checkItemId: item.id,
      }
    } else if (type == 'prep') {
      datatosend = {
        storeId: storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: item.checkHeader.employeeId,
        checkHeaderId: item.checkHeader.id,
        checkPrepId: item.id,
        checkPrepItemId: data.id
      }
    }
    props.prepStartAll(datatosend).then((res) => {
      props.setNotification({
        type: 'success',
        message: "Started"
      });
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  }

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCount(counter => counter + 1);
    }, 1000); // Runs every 1 second
    return () => clearInterval(intervalId); // Clean up function to clear interval when component unmounts
  }, []);

  useEffect(() => {
    if (checkListHashTable) {
      props.getKdsCheckList({
        checklist: Object.values(checkListHashTable || {}),
        checkPerPage,
        itemsPerPage,
        currentItemType,
      });
    }
    if (checkPrepsListHashTable) {
      props.getKdsCheckPrepList({
        checklist: Object.values(checkPrepsListHashTable || {}),
        checkPerPage,
        itemsPerPage,
        currentItemType,
        duplicateDeviceIds
      });
    }
  }, [checkListHashTable, checkPrepsListHashTable, props.bumpLoading]);


  //Code

  const handleActivity = () => {
    setLastActiveTime(new Date());
  };
  

  useEffect(() => {
    // Attach event listeners for user activity
    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);

    // Cleanup event listeners when component unmounts
    return () => {
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
    };
  }, []);
  //

  useEffect(() => {
    if (historyData) {
      let color = historyData[Object.keys(historyData)[0]]?.some(obj => obj.warningColor !== undefined);
      let c
      if (color) {      
         historyData[Object.keys(historyData)[0]].forEach((item) => {
          if (item.warningColor) {
          c=item.warningColor
          }
        })
      }
      setHeaderColor(c ? c : 'green')
      setSelectedHistoryData(Object.keys(historyData)[0]) 
    }
  }, [historyData])

  useEffect(() => {
    if (auth && socketConnected) {
      authenticate({ headers: { 'api-key': auth.syncApiKey }, id: auth.id });
      subscribeToStoreChecks(auth.id);
      getStoreChecks(auth.id);
    }
  }, [socketConnected]);

  useEffect(() => {
    if (checkPrepsListHashTable) {
      props.getKdsCheckPrepList({
        checklist: Object.values(checkPrepsListHashTable || {}),
        checkPerPage,
        itemsPerPage,
        currentItemType,
        duplicateDeviceIds
      });
    }
  }, [duplicateDeviceIds])

  const handleLogout = () => {
    const userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
    const dataToSend = {
      latitude: '92',
      longitude: '92',
      deviceId: deviceInfo.deviceId,
      employeeId: userInfo?.externalId,
      employeeCard: userInfo?.employeeCard,
    };
    props.logout(dataToSend);
    props.history.replace(`${APP_CONFIG.BASE_URL}/checkIn?step=1`);
  }

  const convertUTCDateToLocalDate = (date) => {
    var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    return newDate;
  }


  const getPrepCompletedTime = (value) => {
    // UTC timings
    var utcTime1 = moment.utc(value.prepStartDate).local();
    var utcTime2 = moment.utc(value.prepCompleteDate).local();

    // Calculate the difference in milliseconds
    var diff = utcTime2.diff(utcTime1);
    // Convert the difference to minutes and seconds
    var duration = moment.duration(diff);
    var minutes = Math.floor(duration.asMinutes());
    var seconds = Math.floor(duration.asSeconds()) % 60;
    // Format the minutes and seconds as 00:00
    var formattedTime = moment.utc().startOf('day').add(minutes, 'minutes').add(seconds, 'seconds').format('mm:ss');
    return formattedTime
  }

  const getTimeDifference = (value) => {
    // Get the difference between the current time and the desired time
    const currentTime = moment();
    const desiredTime = moment(value);;

    // Calculate the difference
    const timeDifference = desiredTime.diff(currentTime);

    // Convert the difference to a readable format (e.g., days, hours, minutes, seconds)
    const duration = moment.duration(timeDifference);
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    // Format the result as needed
    // const formattedTimeDifference = `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds, ${milliseconds} milliseconds`;
    var formattedTime = moment.utc().startOf('day').add(hours,'hours').add(minutes, 'minutes').add(seconds, 'seconds').format('hh:mm');
    return formattedTime;
  };

  const footerSelection = (i) => {
    const tempObj = {}
    if (filterData?.[i.name]) {
      tempObj[i.name] = false;
      setFilterData((prev)=>({...prev, ...tempObj}))
    } else {
      tempObj[i.name] = true;
      setFilterData((prev)=> ({...prev, ...tempObj}))
    }
  };

  const getPickupTime = (time) => {
    if (time) {
      const utcTime = moment.utc(time).local().format("h:mm A")
      return utcTime;
    }
    return time
  }

  const handleActiveScreen = () => {
    switch (activeScreenType) {
      case 0: {
        return Object.keys(kdsExpoObject)?.length != 0 && Object.keys(kdsExpoObject).length > 0 ? (
          <KdsExpoStationScreens
            groupObj={kdsExpoObject}
            inActiveData={inActiveData}
            bumpApiCall={bumpApiCall}
            receipePdfApiCall={receipePdfApiCall}
            prepStartAll={prepStartAll}
            convertUTCDateToLocalDate={convertUTCDateToLocalDate}
            toggle={toggle} themeProperties={themeProperties}
            columnCount={columnCount} rowCount={rowCount}
            bumpApiSelected={bumpApiSelected}
            getPrepCompletedTime={getPrepCompletedTime}
            duplicateDeviceIds={duplicateDeviceIds}
            handleDropClick={(dropCheckId) => { setPriorityItem({ ...prioritizedItem, dropItemId: dropCheckId }); handleItemDrop(dropCheckId); }}
            prioritizedItem={prioritizedItem}
            setPriorityItem={setPriorityItem}
            isPrioritize={isPrioritize}
            setPrioritize={setPrioritize}
            setConfirmDropItem={setConfirmDropItem}
            handleLogout={handleLogout}
            duplicateData={duplicateData}
            layoutApi={layoutApi}
            activeScreenType={activeScreenType}
            setToggle={setToggle}
            History={History}
            setHistoryData={setHistoryData}
            showMenu = {showHamburgerMenu}
            setShowMenu = {setShowHamburgerMenu}
            counter={counter}
            lastActiveTime={lastActiveTime}
            setPdfUrl = {setPdfUrl}
            pdfUrl = {pdfUrl}
            setRecipeModalData = {setRecipeModalData}
            filterData={filterData} 
            setFilterData={setFilterData}
            footerSelection={footerSelection}
            handleDragRushApiCall={handleDragRushApiCall}
            handleIsStationEmpty={(val) => setIsStationEmpty(val)}
          />
        ) : <div> 
              <KdsEmptyStation 
                handleLogout={handleLogout} 
                setShowMenu = {setShowHamburgerMenu}
                showMenu = {showHamburgerMenu}
                duplicateData={duplicateData} 
                layoutApi={layoutApi} 
                activeScreenType={activeScreenType} 
                History={History}
              />
            </div>;
      }

      case 1: {
        return Object.keys(kdsObject)?.length != 0 && Object.keys(kdsObject).length > 0 ? (
          <KdsBuildStationScreens
            groupObj={kdsObject}
            receipePdfApiCall={receipePdfApiCall}
            bumpApiCall={bumpApiCall}
            prepStartAll={prepStartAll}
            convertUTCDateToLocalDate={convertUTCDateToLocalDate}
            toggle={false} themeProperties={themeProperties}
            columnCount={columnCount} rowCount={rowCount}
            bumpApiSelected={bumpApiSelected}
            getPrepCompletedTime={getPrepCompletedTime}
            duplicateDeviceIds={duplicateDeviceIds}
            handleLogout = {handleLogout}
            duplicateData = {duplicateData}
            History = {History}
            activeScreenType = {activeScreenType}
            setToggle={setToggle}
            setHistoryData={setHistoryData}
            showMenu = {showHamburgerMenu} 
            setShowMenu = {setShowHamburgerMenu}
            counter={counter}
            handleShowRecallModal = {handleShowRecallModal}
            setRecallData={setRecallData}
            lastActiveTime={lastActiveTime}
            pdfUrl = {pdfUrl}
            setPdfUrl = {setPdfUrl}
            setRecipeModalData = {setRecipeModalData}
            checkPrepsListHashTable={checkPrepsListHashTable}
            filterData={filterData}
            setFilterData={setFilterData}
            footerSelection={footerSelection}
            states={states}
            currentState={currentState}
            toggleState={toggleState}
            getPickupTime={getPickupTime}
          />
        ) : <div> 
              <KdsEmptyStation 
                handleLogout={handleLogout} 
                duplicateData = {duplicateData}
                History={History}
                activeScreenType={activeScreenType}
                handleShowRecallModal={handleShowRecallModal}
                showMenu = {showHamburgerMenu} 
                setShowMenu = {setShowHamburgerMenu}
              />
            </div>;
      }
  
      case 2: {
        return Object.keys(kdsObject)?.length != 0 && Object.keys(kdsObject)?.length > 0 ? (
          <KdsPrepStation
            groupObj={kdsObject}
            receipePdfApiCall={receipePdfApiCall}
            bumpApiCall={bumpApiCall}
            prepStartAll={prepStartAll}
            convertUTCDateToLocalDate={convertUTCDateToLocalDate}
            toggle={false} themeProperties={themeProperties}
            columnCount={columnCount} rowCount={rowCount}
            bumpApiSelected={bumpApiSelected}
            getPrepCompletedTime={getPrepCompletedTime}
            duplicateDeviceIds={duplicateDeviceIds}
            handleLogout={handleLogout}
            duplicateData={duplicateData}
            History={History}
            activeScreenType={activeScreenType}
            setToggle={setToggle}
            setHistoryData={setHistoryData}
            showMenu={showHamburgerMenu}
            setShowMenu={setShowHamburgerMenu}
            counter={counter}
            handleShowRecallModal={handleShowRecallModal}
            setRecallData={setRecallData}
            lastActiveTime={lastActiveTime}
            pdfUrl={pdfUrl}
            setPdfUrl={setPdfUrl}
            setRecipeModalData={setRecipeModalData}
            checkPrepsListHashTable={checkPrepsListHashTable}
            filterData={filterData}
            setFilterData={setFilterData}
            footerSelection={footerSelection}
            states={states}
            currentState={currentState}
            toggleState={toggleState}
            getPickupTime={getPickupTime}
          />
        ) : <div >
            <KdsEmptyStation 
              handleLogout={handleLogout} 
              setShowMenu={setShowHamburgerMenu}
              showMenu={showHamburgerMenu}
              duplicateData={duplicateData}
              History={History}
              activeScreenType={activeScreenType}
              handleShowRecallModal={handleShowRecallModal}
            />
        </div>;
      }
  
      default: return <div />;
    }
  };

  const handleDuplicateCheckedStatus = (name) => {
   if (tempDuplicateCheckedStatus[name]) setTempDuplicateCheckedStatus({ ...tempDuplicateCheckedStatus, [name]: "" });
    else setTempDuplicateCheckedStatus({ ...tempDuplicateCheckedStatus, [name]: HexColorGenerator(name) });
  }

  const getHeaderData = () => {
    const cards = [];
    if (historyData) {
      historyData[Object.keys(historyData)?.find(key => key === selectedHistoryData)]?.forEach((element, index) => {
      if (index === 0) {
            cards.push(
              <div className='color-white w-100 d-flex justify-content-around text-center py-1 pl-2'>
                <div className='w-20'>
                  <div>#{element.checkPrep.checkHeader.number}</div>
                </div>
                <div  className='d-flex text-nowrap justify-content-around w-80'>
                  <div className='text-uppercase pl-2'>
                    { kdsSettings?.displayOrderType && 
                      (
                       <div>{ element?.checkPrep?.checkHeader?.orderTypeName?.length > 15 ? element?.checkPrep?.checkHeader?.orderTypeName?.substring(0,15) + '..': element?.checkPrep?.checkHeader?.orderTypeName }</div>
                      )
                    }
                  </div>
                  <div className='text-uppercase pl-2'>
                    {
                       kdsSettings?.displayRevenueCenter && (
                        <div>{ element?.checkPrep?.checkHeader?.revenueCenterName?.length > 15 ? element?.checkPrep?.checkHeader?.revenueCenterName?.substring(0,15) + '..' : element?.checkPrep?.checkHeader?.revenueCenterName }</div>
                       )
                    }
                  </div>
                </div>
                <div className='pl-8 w-20'>
                  <div >{getTimeDifference(element.expoCompleteDate)}</div>
                </div>
              </div>
            )
          }
      })
    }
    return cards;
  }
  const generateCards = () => {
    const cards = [];
    if (historyData) {
      Object.entries(historyData)?.forEach(([key, value]) => {
        value?.forEach((element, index) => {
          let color = value.some(obj => obj.warningColor !== undefined);
          let c
          if (color) {
            if (element.warningColor) {
              c = element.warningColor
              }
          }   
          if (index === 0) {
            cards.push(
              <div 
                className={cn("col-12 p-2 fs-12 color-black", styles.dataCard)} 
                style={{ background: key === selectedHistoryData ? '#EFF6FF' : '#F6F6F6' }} 
                tabIndex="0"
                role="button"
                onClick={() => { setSelectedHistoryData(key); setHeaderColor(c ? c : 'green'); setCurrentHistoryPage(1) } }
              >
                <div>
                  <div className='row'>
                    <div className='col-4'>
                      <div className=''>#{element?.checkPrep?.checkHeader?.number}</div>
                      <div>{element?.checkPrep?.checkHeader?.stationName}</div>
                      <div></div>
                    </div>
                    <div className='col-4 px-1'>
                      { kdsSettings?.displayOrderType && (element?.checkPrep?.checkHeader?.orderTypeName?.length > 10 ? element?.checkPrep?.checkHeader?.orderTypeName?.substring(0,10) + '..' : element?.checkPrep?.checkHeader?.orderTypeName)}
                      <br/>
                      {
                        kdsSettings?.displayRevenueCenter && (
                          <span> {element?.checkPrep?.checkHeader?.revenueCenterName?.length > 10 ? element?.checkPrep?.checkHeader?.revenueCenterName?.substring(0,10) + '..' : element?.checkPrep?.checkHeader?.revenueCenterName } </span>
                        )
                      }
                    </div>
                    <div className='col-4 pl-1 pr-2 text-center text-uppercase'>
                      <div style={{ backgroundColor: c ? c : 'green', borderRadius: '5px' }}>{ getTimeDifference(element.expoCompleteDate)}</div>
                      <div>{element.checkPrep.checkHeader.employeeFirstName && element.checkPrep.checkHeader.employeeLastName && element.checkPrep.checkHeader.employeeFirstName + ' ' + element.checkPrep.checkHeader.employeeLastName.substring(0, 3) + '..'}</div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        });
      })
    }

    return cards;
  };

  const tableData = {
    headervalues: ['S.no', 'Items', 'QTY', 'Notes'],
  }
  const generateTableRows = () => {

    const tableRows = [];
    if (historyData) {
      const totalHistoryItemsPerPage = 5;
      const startIndex = (currentHistoryPage - 1) * totalHistoryItemsPerPage;
      const endIndex = startIndex + totalHistoryItemsPerPage;
    historyData[selectedHistoryData]?.forEach((item,index) => {
        item['slno'] = index+1;
      })
      const paginatedData = historyData[selectedHistoryData]?.slice(startIndex,endIndex);

      paginatedData?.forEach((element) => {
        const tableCells = [];
        
        tableCells.push(
          <>
            <td className='p-3 text-left' >
              #{element.slno}
            </td>
            <td className=''>
              <div className='fs-12'>
                {element.name}   
              </div>
              {element.modifiers?.map((i) => {
                return (
                  <>
                    <div className='pl-1' style={{fontSize: 'Max(1.1vw, 1.1vh)'}}>-&nbsp;{i?.quantity > 1 ? i?.quantity + 'x' : ''}&nbsp;{i.name}</div>  
                    {
                      i.modifiers?.map((i) => {
                        return (
                          <>
                            <div className='pl-2' style={{fontSize: 'Max(1.1vw, 1.1vh)'}}>-&nbsp;{i?.quantity > 1 ? i?.quantity + 'x' : ''}&nbsp;{i.name}</div>
                            {
                              i.modifiers?.map((i) => {
                                return (
                                  <>
                                    <div className='pl-3' style={{fontSize: 'Max(1.1vw, 1.1vh)'}}>-&nbsp;{i?.quantity > 1 ? i?.quantity + 'x' : ''}&nbsp;{i.name}</div>
                                    {
                                      i.modifiers?.map((i) => {
                                        return (
                                        
                                            <div className='pl-4' style={{fontSize: 'Max(1.1vw, 1.1vh)'}}>-&nbsp;{i?.quantity > 1 ? i?.quantity + 'x' : ''}&nbsp;{i.name}</div>
                                          
                                        )
                                      })
                                    } 
                                  </>
                                )
                              })
                            } 
                            </>
                        )
                      })
                    } 
                    </>
                )
               
              })} 
             
             
            </td>
            <td className='text-left'>
              {'x' + element.quantity}
            </td>
            <td className='text-left'>
              {element.comment ? element.comment : '--'}
            </td>
          </>)

        tableRows.push(<tr>{tableCells}</tr>);

      })
    }   

    return tableRows;
  };

  const generateRecallCards = () => {
    const cards = [];
    if (testRecall) {
      testRecall.forEach((el, i) => {
        el?.forEach((element, index) => {
          let color = el.some(obj => obj.warningColor !== undefined);
          let c;
          if (color && element.warningColor) {
            c = element.warningColor;
          }
          if (index === 0) {
            cards.push(
              <div
                className={cn("col-12 p-2 fs-14 color-black", styles.dataCard)}
                style={{ background: i === selectedRecallData ? '#EFF6FF' : '#F6F6F6' }}
                onClick={() => {
                  setSelectedRecallData(i);
                  setHeaderColor(c ? c : 'green');
                  setCurrentRecallPage(1);
                }}
              >
                <div>
                  <div className='row'>
                    <div className='col-4'>
                      <div>#{element?.checkPrep?.checkHeader?.number}</div>
                      <div>{element?.checkPrep?.checkHeader?.stationName}</div>
                    </div>
                    <div className='col-4 px-1 d-flex flex-column'>
                      {kdsSettings?.displayOrderType &&
                        (element?.checkPrep?.checkHeader?.orderTypeName?.length > 7
                          ? element?.checkPrep?.checkHeader?.orderTypeName?.substring(0, 7) + '..'
                          : element?.checkPrep?.checkHeader?.orderTypeName)}
                      {kdsSettings?.displayRevenueCenter && (
                        <span>
                          {element?.checkPrep?.checkHeader?.revenueCenterName?.length > 7
                            ? element?.checkPrep?.checkHeader?.revenueCenterName?.substring(0, 7) + '..'
                            : element?.checkPrep?.checkHeader?.revenueCenterName}
                        </span>
                      )}
                    </div>
                    <div className='col-4 text-center'>
                      <div
                        style={{ backgroundColor: c ? c : 'green', borderRadius: '5px' }}
                        className='color-white'
                      >
                        {getRecallTime(element?.bumpTime)}
                      </div>
                      <div className='text-uppercase'>
                        {element?.checkPrep?.checkHeader?.employeeFirstName &&
                          element?.checkPrep?.checkHeader?.employeeLastName &&
                          (element?.checkPrep?.checkHeader?.employeeFirstName?.length > 4
                            ? element?.checkPrep?.checkHeader?.employeeFirstName?.substring(0, 4) + '..'
                            : element?.checkPrep?.checkHeader?.employeeFirstName +
                              element?.checkPrep?.checkHeader?.employeeLastName?.substring(0, 3) + '..')}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        });
      });
    }
    return cards;
  };  

  const getRecallTime = (value) => {
    
    // Convert the difference to a readable format (e.g., days, hours, minutes, seconds)
    const duration = moment.duration(value);
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    // Format the result as needed
    var formattedTime = moment.utc().startOf('day').add(hours,'hours').add(minutes, 'minutes').add(seconds, 'seconds').format('mm:ss');
    return formattedTime;
  };

  const getRecallHeaderData = () => {
    const cards = [];
    if (testRecall) {
      testRecall.forEach((el, i) => {
        let key = el[0]?.checkPrep?.id;
        if (i === selectedRecallData) {
          el?.forEach((element, index) => {
            if (index === 0) {
              cards.push(
                <div className="color-white w-100 d-flex justify-content-around">
                  <div>
                    <div>#{element?.checkPrep?.checkHeader?.number}</div>
                  </div>
                  <div className="d-flex">
                    <div className="text-uppercase pl-5">
                      {kdsSettings?.displayOrderType && (
                        <div>
                          {element?.checkPrep?.checkHeader?.orderTypeName?.length > 15
                            ? element?.checkPrep?.checkHeader?.orderTypeName?.substring(0, 15) + ".."
                            : element?.checkPrep?.checkHeader?.orderTypeName}
                        </div>
                      )}
                    </div>
                    <div className="text-uppercase pl-5">
                      {kdsSettings?.displayRevenueCenter && (
                        <div>
                          {element?.checkPrep?.checkHeader?.revenueCenterName?.length > 15
                            ? element?.checkPrep?.checkHeader?.revenueCenterName?.substring(0, 15) + ".."
                            : element?.checkPrep?.checkHeader?.revenueCenterName}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="pl-8">
                    <div className="color-white">{getRecallTime(element?.bumpTime)}</div>
                  </div>
                </div>
              );
            }
          });
        }
      });
    }
    return cards;
  };  

  const recallTableData = {
    headervalues: ['', 'Items', 'QTY', 'Notes', "Time"],
  }
  const generateRecallTableRows = () => {

    const tableRows = [];
    if (recallData) {
      const totalRecallItemsPerPage = 5;
      const startIndex = (currentRecallPage - 1) * totalRecallItemsPerPage;
      const endIndex = startIndex + totalRecallItemsPerPage;
      const paginatedData = testRecall[selectedRecallData]?.slice(startIndex,endIndex);
      const statusEightItems = [];

      paginatedData?.forEach((element, index) => {
        const tableCells = [];
        if(element?.buildStatus === 8) statusEightItems.push(element);
        tableCells.push(
          <>
            <td className='p-3 text-left' >
              <input type='checkbox' checked={true} style={{accentColor: 'green', width: '20px', height: '20px'}}></input>
            </td>
            <td className=''>
              <div className='fs-12'>
                {element.name}   
              </div>
              {element.modifiers?.map((i) => {
                return (
                  <>
                    <div className='pl-2' style={{fontSize: 'Max(1.1vw, 1.1vh)'}}>-&nbsp;{i?.quantity > 1 ? i.quantity + 'x' : ''}&nbsp;{i.name}</div>  
                    {
                      i.modifiers?.map((i) => {
                        return (
                          <>
                            <div className='pl-3' style={{fontSize: 'Max(1.1vw, 1.1vh)'}}>-&nbsp;{i?.quantity > 1 ? i.quantity + 'x' : ''}&nbsp;{i.name}</div>
                            {
                              i.modifiers?.map((i) => {
                                return (
                                  <>
                                    <div className='pl-4' style={{fontSize: 'Max(1.1vw, 1.1vh)'}}>-&nbsp;{i?.quantity > 1 ? i.quantity + 'x' : ''}&nbsp;{i.name}</div>
                                    {
                                      i.modifiers?.map((i) => {
                                        return (
                                        
                                            <div className='pl-5' style={{fontSize: 'Max(1.1vw, 1.1vh)'}}>-&nbsp;{i?.quantity > 1 ? i.quantity + 'x' : ''}&nbsp;{i.name}</div>
                                          
                                        )
                                      })
                                    } 
                                  </>
                                )
                              })
                            } 
                            </>
                        )
                      })
                    } 
                    </>
                )
               
              })} 
             
             
            </td>
            <td className='text-left'>
              {'x' + element.quantity}
            </td>
            <td className='text-left'>
              {element.comment ? element.comment : '--'}
            </td>
            <td className='text-left'>
              {getRecallTime(element?.bumpTime)}
            </td>
          </>)

        tableRows.push(<tr>{tableCells}</tr>);

      })
    }
    return tableRows;
  };

  const handleRecallClick = () => {
    const data = testRecall[selectedRecallData]
    const item = testRecall && testRecall[selectedRecallData] && testRecall[selectedRecallData].length > 0 &&
      testRecall[selectedRecallData][0]

    const dataToSend = {
      storeId: storeId,
      deviceId: deviceInfo.deviceId,
      employeeId: item?.checkPrep.checkHeader.employeeId,
      checkHeaderId: item?.checkPrep.checkHeader.id,
      checkPrepId: item?.checkPrep.id,
      items: []
    }
      
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      let obj = { entityId: element.entityId, isModifier: element.isModifier }
      dataToSend['items'].push(obj);
    }

    console.log({dataToSend})

    let newRecallData = testRecall;
    newRecallData.splice(selectedRecallData, 1);
    setIsRecallOpen(false);

    props.recallApiCall(dataToSend)?.then((res) => {
      props.setNotification({
        type: 'success',
        message: "Item Recall Completed"
      })
    })?.catch((err) => {
      props.setNotification({
        type: 'danger',
        message: "Item Recall Failed"
      })
    });
    
  }
  
  const handleDuplicateToggleDisable = (data) => {
  return (
      deviceInfo.deviceId === data.deviceId ||
      deviceInfo.kdsMirrorDeviceId === data.deviceId ||
      data.kdsMirrorDeviceId === deviceInfo.deviceId
    )
  };

  const handleDragRushApiCall = (dragRushModalData, dragRushInputTime,  setDragRushInputTime, setDragRushModalData) => {
    
    const data = dragRushModalData?.data;
    const checkData = dragRushModalData?.checkData; 

    if(data && checkData){
      const payload = {
        storeId: dragRushModalData?.storeId, 
        deviceId: deviceInfo.deviceId,
        employeeId: checkData?.employeeId,
        checkHeaderId: checkData?.checkHeaderId,
        checkPrepId: checkData?.checkPrepId,
        entityId: data?.entityId, 
        isModifier: data?.isModifier
      }
  
      if(dragRushModalData?.modalName === LABEL().KDS_DRAG){
        payload.reScheduleAsRush = false;
        if(dragRushInputTime?.mins < 10){
          payload.reScheduleBy = `00:0${dragRushInputTime?.mins}:00`;
        }
        else {
          payload.reScheduleBy = `00:${dragRushInputTime?.mins}:00`;
        }
      }
      else if(dragRushModalData?.modalName === LABEL().KDS_RUSH){
        payload.reScheduleAsRush = true;
        payload.reScheduleBy = '00:00:00';
      }

      props.checkReScheduleRequest(payload).then((res) => {
        setDragRushInputTime({isConformationPopUpOpen: false, hours: 0, mins: 0, seconds:0});
        setDragRushModalData({
            isOpen: false, data: {}, modalName: '',  checkData: {},
            storeId: undefined, itemId: undefined, itemName: undefined,
        });
        props.setNotification({
        type: 'success',
        message: `Item ${dragRushModalData?.modalName === LABEL().KDS_DRAG ? LABEL().KDS_DRAG : LABEL().KDS_RUSH} Successful`
      })}).catch(() => 
        props.setNotification({
          type: 'danger',
          message: `Item ${dragRushModalData?.modalName === LABEL().KDS_DRAG ? LABEL().KDS_DRAG : LABEL().KDS_RUSH} Failed`
        })
      );
    }
  }

  return (
    <div className={cn("row mx-0 h-100 w-100 bg-black color-white", styles.kdsBg)}>
      {/* {socketConnected ? ( */}
      
        {props.loading && <Loader />}
        {/* <div className="w-10 p-1 h-100" style={socketConnected ? {} : { backgroundColor: 'red' }}>
          <KdsSideBar
            allCount={allCount}
            openCount={openCount}
            lastHourCount={lastHourCount}
            lastCheckDate={lastCheckDate}
            handleLogout={handleLogout}
            activeScreenSelection={handleScreenSelection}
            activeScreenType={activeScreenType}
            allDayFilter={allDayFilter}
            toggle={toggle}
            setPrepSelectedObjects={setPrepSelectedObjects}
            prepSelectedObjects={prepSelectedObjects}
            bumpApiSelected={bumpApiSelected}
            layoutApi={layoutApi}
            isLayoutOpen={isLayoutOpen}
            duplicateData={duplicateData}
            setPriorityItem={setPriorityItem}
            isPrioritize={isPrioritize}
            setPrioritize={setPrioritize}
          />
        </div> */}
        <div className={cn('p-0 h-100 w-100 mx-0')}>
          {handleActiveScreen()}
        </div>
      
      <Modal
        isOpen={isOpen}
        isModalCenter customClass2={styles.maxWidth}
      >
        <div style={{ backgroundColor: '#FFFFFF', borderRadius: '28px' }}>
          <div className="px-2 py-2 text-right">
            <i
              role="presentation"
              onClick={() => setIsopen(false)}
              className="fa fa-times fs-30"
              aria-hidden="true"
            />
          </div>
          <div className='text-center text-dark mb-5 ml-5 mr-5'>
            {errordata}

          </div>
        </div>
      </Modal>
      <Modal
        isOpen={isLayoutOpen}
        isModalCenter customClass2={styles.maxWidth}
        customClass3={styles.rad}
      >
        <div style={{ backgroundColor: '#FFFFFF' }}>
          
          <div className="d-flex px-3 mb-3 py-2 text-right justify-content-between" style={{color:'black', backgroundColor : '#D8D8D8'}}>
          <div>
            Layout
          </div>
           <div>
              <i
                role="presentation"
                onClick={() =>{setIsLayoutopen(false) ; setShowHamburgerMenu(false)}}
                className="fa fa-times fs-22"
                aria-hidden="true"
              />
           </div>
           
          </div>
          <div className='text-center text-dark mb-4'>
            <div >
              {layoutdata?.map((data, index) => {
                return (
                  <>
                    <div className='row text-center'>
                      <div className='col-6 fw-400 text-left pl-5 fs-14' >{data.name}</div>
                      <div className='col-6'>
                        <ToggleSwitch
                          id={data.name}
                          isToggled={data.enabled}
                          handleToggle={() => layoutUpdate(data)}
                        />
                      </div>
                    </div>
                    <div style={{ border: index !== layoutdata.length-1?"1px solid #CAC4D0":'', margin: (index !== layoutdata.length-1) && '2% 0%'}}></div>
                  </>
                )
              })}
            </div>

          </div>
        </div>
      </Modal>
      <Modal
        isOpen={isDuplicatePopUpOpen}
        isModalCenter customClass2={styles.maxWidth}
        customClass3={styles.rad}

      >
        <div className={styles.duplicatePopUpModalAlignment}>
          <div className="d-flex px-3 py-2 mb-3 text-right justify-content-between w-100" style={{color:'black', backgroundColor : '#D8D8D8'}}>
            <div>
              Duplicate order
            </div>
            <div>
              <i
                role="presentation"
                onClick={() => {setIsDuplicatePopUpOpen(false); setTempDuplicateCheckedStatus(duplicateCheckedStatus); setShowHamburgerMenu(false)}}
                className="fa fa-times fs-22"
                aria-hidden="true"
              />
            </div>
            
          </div>
          <div className={cn('text-center text-dark mb-3', styles.duplicatePopUpModal)}>
            <div>
              {duplicatePopupData?.length > 0 && duplicatePopupData?.map((data,index) => {
                  return (
                    <div key={data?.name} className='p-1'>
                    <div className='row text-center'>
                      <div className=' col-6 fw-600 text-left'>{data.name}</div>
                      <div className=' col-6'>
                          <ToggleSwitch
                          id = {data?.name}
                          isToggled={tempDuplicateCheckedStatus[data.deviceId] || (tempDuplicateCheckedStatus[data.kdsMirrorDeviceId] && handleDuplicateToggleDisable(data)) ? true : false}
                          handleToggle={() => handleDuplicateCheckedStatus(data.deviceId)}
                            disabled={handleDuplicateToggleDisable(data)}
                          />
                        </div>
                      </div>
                    <div style={{ border: index !== duplicatePopupData?.length - 1 ? "1px solid #CAC4D0" : '' }}></div>
                    </div>
                )
                })}
            </div>
          </div>
          <div
            role="button"
            className={cn('color-white btn-ripple p-2 w-30 mb-3 text-center', styles.popUpBtnColor)}
            onClick={() => {
              setFilterData({});
              setIsDuplicatePopUpOpen(false);
              setDuplicateCheckedStatus(tempDuplicateCheckedStatus);
              setDuplicateDeviceIds(tempDuplicateCheckedStatus);
              setShowHamburgerMenu(false);
            }}
          >
            {LABEL().KDS_SUBMIT}
          </div>
        </div>
      </Modal>

      <Modal isOpen={history}>
        <div className={cn('d-flex', styles.historyData)}>
          <div className={cn('col overflowXHidden overflowY', styles.orderHistory)}>
            <div style={{ paddingTop: '0.5rem' }}>
              <div
                className="d-flex"
                style={{
                  marginBottom: '0.5rem',
                  justifyContent: 'space-around',
                }}
              >
                <div className={styles.orderHistoryText}>
                  <span>Order History</span>
                </div>
                <div className={styles.filterIcon}>
                  <img
                    src={filterIcon}
                    alt="filterIcon"
                    width="18px"
                    height="18px"
                  />
                </div>
                <div className={styles.filterIcon}>
                  <img
                    src={sortIcon}
                    alt="sortIcon"
                    width="18px"
                    height="18px"
                  />
                </div>
              </div>
              <div className='pr-1' style={{overflow:'scroll',height:'55vw'}}>
                {generateCards()}
              </div>
            </div>
          </div>
          <div className={cn(styles.bar)}></div>
          <div className={styles.orderDetail}>
            <div className={cn('w-100 d-flex')} style={{backgroundColor:headerColor}}>
              {/* <div className='d-flex w-100 p-2' style={{border: '1px solid red'}}>
              {getHeaderData()}
              <div className='px-1 py-1 text-right' >
                <img
                  src={closeIcon}
                  alt="closeIcon"
                  width="24px"
                  onClick={() => setIsHistory(false)}
                />
                </div>
              </div> */}
              <div className='w-100 d-flex justify-content-center align-items-center'>
                {getHeaderData()}
              </div>
              <div className='w-10 d-flex justify-content-end' style={{color:'#ffff'}}>
                <i role='button' className="fa fa-times fs-30 px-2" onClick={() => setIsHistory(false)} />
               {/* <img
                  src={closeIcon}
                  alt="closeIcon"
                  width="24px"
                  onClick={() => setIsHistory(false)}
                /> */}
              </div>
            </div>
            <div className='overflowY' style={{height: '80%'}}>
              <table className={cn('w-95 color-black',styles.card_table)}>
                <thead>
                  <tr style={{height:'30px'}} >
                    {tableData.headervalues.map((header, index) => (
                      <th  key={index} className={cn('fw-600 fs-18',styles.headerText,'col-1' )}>
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>{generateTableRows()}</tbody>  
              </table>
            </div>
            <div className={cn('d-flex w-100 justify-content-between', styles.footer)} style={{bottom:'7px'}}>
              <div className='pl-2'>
                <div role="button" className={styles.LeftArrow} style={{backgroundColor : currentHistoryPage - 1 === 0 ? "gray" : '#6A4DAE'}} onClick = {() => {
                  if(currentHistoryPage > 1){
                    let page = currentHistoryPage-1;
                    setCurrentHistoryPage(page);
                  }
                }}>
                  <img
                    src={LessThanIcon}
                    alt="LessThanIcon"
                    width="12px"
                  />
                  <span className={styles.Zero}>{currentHistoryPage - 1}</span>
                </div>
              </div>
              {/* <div className='d-flex'>
                <div className={cn(styles.cancelBut, 'mr-1')} >
                  <span>CANCEL</span>
                </div>
                <div className={cn(styles.printBut, 'ml-1')}>
                  <span>PRINT</span>
                </div>
              </div> */}
              <div className='pr-2'> 
                <div role="button" className={cn(styles.LeftArrow, styles.rightArrow)} 
                  style={{backgroundColor : ((totalHistoryPage - currentHistoryPage === 0 ) || isStationEmpty) ? "gray" : '#6A4DAE'}}
                  onClick={() => {
                  if(currentHistoryPage < totalHistoryPage){
                    let page = currentHistoryPage+ 1;
                    setCurrentHistoryPage(page);
                  }
                }}>
                  <span className={styles.Zero}>{totalHistoryPage - currentHistoryPage >=0 ? totalHistoryPage - currentHistoryPage : 0}</span>

                  <img
                    src={greaterIcon}
                    alt="greaterIcon"
                    width="12px"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal isOpen = {isRecallOpen}>
        <div className={cn('d-flex', styles.historyData)}>
          <div className={cn('col overflowXHidden overflowY', styles.orderHistory)}>
            <div style={{ paddingTop: '0.5rem' }}>
              <div
                className="d-flex"
                style={{
                  marginBottom: '0.5rem',
                  justifyContent: 'space-around',
                }}
              >
                <div className={styles.orderHistoryText} style={{width: '14rem'}}>
                  <span>Recall</span>
                </div>
                {/* <div className={styles.filterIcon}>
                  <img
                    src={filterIcon}
                    alt="filterIcon"
                    width="18px"
                    height="18px"
                    onClick={() => {
                      console.log('FilterIcon');
                    }}
                  />
                </div>
                <div className={styles.filterIcon}>
                  <img
                    src={sortIcon}
                    alt="sortIcon"
                    width="18px"
                    height="18px"
                    onClick={() => {
                      console.log('SortIcon');
                    }}
                  />
                </div> */}
              </div>
              <div className='pr-1' style={{overflow:'scroll',height:'55vw'}}>
                {generateRecallCards()}
              </div>
            </div>
          </div>
          <div className={cn(styles.bar)}></div>
          <div className={styles.orderDetail}>
            {/* <div className={cn('w-100 d-flex')} style={{backgroundColor:headerColor}}> */}
            <div className={cn('w-100 d-flex')} 
              style={{backgroundColor: (testRecall[selectedRecallData]?.length > 0 && testRecall[selectedRecallData][0]?.warningColor) || 'green'}}
            >
              <div className='w-100 d-flex justify-content-center align-items-center'>
                {getRecallHeaderData()}
              </div>
              <div className='w-10 d-flex justify-content-end' style={{color:'#ffff'}}>
                <i role="button" className="fa fa-times fs-30 px-2" onClick={() => handleShowRecallModal()} />
               {/* <img
                  src={closeIcon}
                  alt="closeIcon"
                  width="24px"
                  onClick={() => handleShowRecallModal()}
                /> */}
              </div>
            </div>
            <div className='overflowY' style={{height: '80%'}}>
              <table className={cn('w-90 color-black',styles.card_table)}>
                <thead>
                  <tr style={{height:'30px'}} >
                    {recallTableData.headervalues.map((header, index) => (
                      <th  key={index} className={cn('fw-600 fs-18',styles.headerText, index === 1 ? 'col-2' : 'col-1', index === 0 && 'p-3' )}>
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>{generateRecallTableRows()}</tbody>  
              </table>
            </div>
            <div className={cn('d-flex w-100 justify-content-between', styles.footer)} style={{bottom:'7px'}}>
              <div className='pl-2'>
                <div role="button" className={styles.LeftArrow} style={{backgroundColor : currentRecallPage - 1 === 0 ? "gray" : '#6A4DAE'}} onClick = {() => {
                  if(currentRecallPage > 1){
                    let page = currentRecallPage-1;
                    setCurrentRecallPage(page);
                  }
                }}>
                  <img
                    src={LessThanIcon}
                    alt="LessThanIcon"
                    width="12px"
                  />
                  <span className={styles.Zero}>{currentRecallPage - 1}</span>
                </div>
              </div>
              <div className='d-flex'>
                { 
                  (testRecall?.length > 0 && Object.keys(kdsObject)?.length != 0 && Object.keys(kdsObject)?.length > 0) && (
                    <div role="button" className={cn(styles.printBut, 'ml-1')} onClick={() => handleRecallClick()}>
                      <span>Recall</span>
                    </div>
                  )
                }
              </div>
              <div className='pr-2'> 
                <div role="button" className={cn(styles.LeftArrow, styles.rightArrow)} 
                  style={{backgroundColor : totalRecallPage - currentRecallPage === 0 ? "gray" : '#6A4DAE'}}
                  onClick={() => {
                  if(currentRecallPage < totalRecallPage){
                    let page = currentRecallPage+ 1;
                    setCurrentRecallPage(page);
                  }
                }}>
                  <span className={styles.Zero}>{totalRecallPage - currentRecallPage}</span>

                  <img
                    src={greaterIcon}
                    alt="greaterIcon"
                    width="12px"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal isOpen={pdfUrl.length !== 0 && recipeModalData?.isOpen} style={{backgroundColor: 'background: var(--color, #FFF)', height: '98vh' }} customClass2={'mx-3 mw-100'} customClass3={'bg-white'} >
                  <div className='p-3'>
                    <div className='d-flex justify-content-between'>
                      <div className='text-dark pt-2' style={{ fontSize: '1.3rem', fontWeight: '500', lineHeight: '20px' }}>
                        {recipeModalData?.itemName + '-Receipe.PDF'}
                      </div>
                      <div>
                        <img src={pdfCancel} role="presentation" onClick={() => {
                          setRecipeModalData({isOpen: false, itemName: ''})
                          setPdfUrl([])
                        }} alt="pdfCancel" style={{ width: '2rem' }} />
                      </div>
                    </div>
                    <div>
                      <div className='pt-3' style={{ overflowY: 'auto', color: 'var(--light-text-1, #4E4E4E)', fontSize: '1.2rem', fontStyle: 'normal', fontWeight: '400', lineHeight: '40px' }}>
                        <iframe src={pdfUrl} title="PDF Viewer" style={{ width: '93vw', height: '80vh' }} allowFullScreen />
                      </div>
                    </div>
                    <div>
                    </div>
                  </div>
      </Modal>
      {/* // ) : (
      //   <div className={cn('p-2 fw-600 fs-50 d-flex flex-column mx-0 justify-content-center text-left col-4 h-100')}>
      //     {LABEL().CONNECTING_TO_NEWTWORK}
      //     <div className={cn(styles.animationStripes, 'bg-lightblue')} />
      //   </div>
      // )} */}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getKdsCheckList,
  getKdsCheckPrepList,
  setNotification,
  bumpApiCall,
  receipePdfApiCall,
  layoutApiCall,
  duplicateData,
  reprioritize,
  layoutUpdateApiCall,
  prepStartAll,
  logout,
  updatePrepObject,
  getAllCheckPreps,
  getModifierRecipePdf,
  checkReScheduleRequest,
  recallApiCall
}, dispatch);

const mapStateToProps = ({
  oauth, storeChecks, kds
}) => ({
  loading: storeChecks.loading || kds.loading,
  bumpLoading : storeChecks.bumpLoading,
  deviceInfo: oauth.deviceInformation,
  auth: oauth.authInfo,
  checkListHashTable: storeChecks.checkListHashTable,
  checkPrepsListHashTable: storeChecks.checkPrepsListHashTable,
  UpdatedcheckPrepsListHashTable: storeChecks.UpdatedcheckPrepsListHashTable,
  expoObject: kds.expoObject,
  prepObject: kds.prepObject,
  kdsObject: kds.kdsObject,
  kdsExpoObject: kds.kdsExpoObject,
  inActiveData: kds.inActiveData,
  lastHourCount: kds.lastHourCount,
  lastCheckDate: kds.lastCheckDate,
  socketConnected: oauth.socketConnected,
  footerItemSelectionId: kds.footerItemSelectionId,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KitchenDisplaySystem);
